import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const billing = accountId => {
  let menuItems = [
    {
      icon: 'diamond',
      // imageUrl: '/brand-assets/settings-6-line',
      label: 'BILLING',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/billing`),
      toStateName: 'billing_settings_index',
      // featureFlag: FEATURE_FLAGS.MACROS,
      // showOnlyOnCloud: true,
    }
  ];
  console.info(accountId, "===============accountId===============")
  if (accountId == window?.chatwootConfig?.testMerchantId) {
    menuItems = [
      {
        icon: 'diamond',
        // imageUrl: '/brand-assets/settings-6-line',
        label: 'BILLING',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/billing`),
        toStateName: 'billing_settings_index',
        // featureFlag: FEATURE_FLAGS.MACROS,
        // showOnlyOnCloud: true,
      },
      {
        icon: 'folder',
        label: 'PRODUCTS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/product/list`),
        toStateName: 'product_list_index',
        // featureFlag: FEATURE_FLAGS.MACROS,
        // showOnlyOnCloud: true,
      },
      {
        icon: 'list',
        label: 'ORDERS',
        hasSubMenu: false,
        meta: {
          permissions: ['administrator'],
        },
        toState: frontendURL(`accounts/${accountId}/order/list`),
        toStateName: 'order_list_index',
        // featureFlag: FEATURE_FLAGS.MACROS,
        // showOnlyOnCloud: true,
      },
    ];
  }
  return {
    parentNav: 'billing',
    routes: [
      'billing_index',
      'billing_settings_index',
      'product_list_index',
      'order_list_index'
    ],
    menuItems: menuItems
  }
};

export default billing;